<template >
  <div style="padding-left: 7px" >
    <el-row >
      <el-button
          style="float: right"
          type="primary"
          @click="textMode=!textMode"
          :icon="textMode?'el-icon-menu':'el-icon-tickets'" ></el-button >
    </el-row >
    <el-input
        type="textarea"
        v-model="textContent"
        :rows="content&&content.length?content.length:2"
        v-if="textMode" />
    <template v-else >
      <el-row
          v-for="(row,idx) in content"
          :key="idx"
          style="padding-top: 4px"
          type="flex" >
        <el-col >
          <el-row v-if="colSPlitter" >
            <el-col
                v-for="(col,cidx ) in row"
                :md="colSizes[cidx]"
                :key="cidx" >
              <el-input
                  :type="!!cidx?'textarea':null"
                  v-model="content[idx][cidx]"
                  :rows="2"
                  @input="report(true)" ></el-input >
            </el-col >
          </el-row >
          <el-row v-else >
            <el-input

                v-model="content[idx]"
                :rows="2"
                @input="report(true)" ></el-input >
          </el-row >
        </el-col >
        <el-col style="width: 100px" >
          <el-button
              style="float: right"
              type="success"
              @click="doRow(idx,'add')"
              icon="el-icon-plus" ></el-button >
          <el-button
              v-if="canReorderRows"
              type="success"
              @click="doRow(idx,'up')"
              icon="el-icon-upload2" ></el-button >
          <el-button
              v-if="canReorderRows"
              type="success"
              @click="doRow(idx,'down')"
              icon="el-icon-download" ></el-button >
          <el-button
              type="warning"
              @click="doRow(idx,'remove')"
              icon="el-icon-circle-close" ></el-button >
        </el-col >
      </el-row >
    </template >
    <!--    <el-row>-->
    <!--      <el-button style="float: right" type="success" @click="doRow(idx,'add')" icon="el-icon-plus"></el-button>-->
    <!--      <el-button style="float: left" type="success" @click="undo" icon="el-icon-plus"></el-button>-->
    <!--    </el-row>-->
  </div >
</template >

<script >

let undoCache = []
export default {
  name: "SCSimpleStrArray",

  props: {
    canReorderRows: {type: Boolean, default: false},
    type: {type: String, default: 'website'},
    disabled: {type: Boolean, default: false},
    colSPlitter: {default: null, type: String},
    rowSpliter: {default: '|', type: String},
    value: {default: null},
  },
  computed: {
    textContent: {
      get() {
        let str = []
        if (this.colSPlitter) {
          this.content.forEach(rw => str.push(rw.join(this.colSPlitter)))
          return str.join(this.rowSpliter)
        }
        return this.content.join(this.rowSpliter)
      },
      set(v) {
        this.parseValue(v)
        this.$emit('input', v)
      }
    },

  },

  data() {
    return {
      colSizes: [6, 18],


      textMode: false,
      content: null,
      errorMsg: null,
      optionRec: {},
      loaded: false,
    };
  },
  watch: {
    value(val, oldVal) {
      if (val == oldVal) return
      this.parseValue();
    },
    // content(val, oldVal) {
    //   if (val != oldVal && this.value != this.content) {
    //     this.$emit("input", this.content);
    //
    //     // this.handleTriggers();
    //   }
    // },
  },
  mounted() {
    this.parseValue();
  },

  methods: {
    doRow(idx, act) {
      if (act == 'remove') {
        this.content.splice(idx, 1)
        this.report()
      }
      if (act == 'up') {
        if (idx - 1 < 0) return
        const upR = this.content[idx - 1], thisR = this.content[idx]
        this.content[idx - 1] = thisR
        this.content[idx] = upR
        this.report()
      }
      if (act == 'down') {
        if (idx - 1 < 0) return
        const dR = this.content[idx + 1], thisR = this.content[idx]
        this.content[idx + 1] = thisR
        this.content[idx] = dR
        this.report()
      }
      if (act == 'add') {
        const newRow = this.colSPlitter ? ['', ''] : '';
        if (idx < this.content.length - 1)
          this.content.splice(idx, 0, newRow);
        else
          this.content.push(newRow)
      }
    },
    report(dontRecUndo) {
      let str = []
      if (this.colSPlitter) {

        this.content.forEach(rw => str.push(rw.join(this.colSPlitter)))
      }
      else str = this.content
      _log_('SCSimpleStrArray....', str)
      this.$emit('input', str.join(this.rowSpliter))
      this.$emit('change', str.join(this.rowSpliter))
      if (!dontRecUndo) undoCache.push(JSON.stringify(this.content))
    },
    undo() {
      if (!undoCache.length) return
      this.content = JSON.parse(undoCache.pop())
      this.report(true)
    },
    parseValue(v) {
      v = v ? v : this.value
      if (!v) {
        this.content = this.colSPlitter ? [['', '']] : [''];
        return
      }
      // _log_('SCSimpleStrArray....',v)
      this.loaded = false;
      const parts = v.split(this.rowSpliter), rows = this.colSPlitter ? parts.map(rw => {

        const cols = rw.split(this.colSPlitter)
        if (cols.length == 1) return ['', cols[0]]
        if (cols.length > 2) {
          const frst = cols.shift()
          return [frst, cols.join(this.colSPlitter)]
        }
        return cols
      }) : parts

      this.content = rows;

      this.loaded = true;
      return this.content;
    },
  },
};
</script >

<style >
/* label.el-checkbox {
	min-height:42px;
} */
.el-checkbox__inner {
  border-color: #004588;
}

.el-checkbox__inner:hover {
  border-color: #c0c4cc;
}

.field-valid {
  color: #004588;
}

.field-invalid {
  color: red;
}

/* .mobile-input {
  z-index: 20002;

  background-color: aliceblue;
  opacity: 1;
} */
.mobile-container {
  z-index: 2;
  position: fixed;
  top: 60px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: aliceblue;
  opacity: 0.9;
}


.avail-opts {
  padding: 5px 0;
  color: #9e9e9e;
  font-size: 14px;
}
</style >
